const enMessages = {
  /* 01.General */
  "chat.end": "Restart your chat conversation",
  "chat.endall": "End Chat",
  "chat.cancel": "Cancel",
  "chat.cookie":
    "This digital assistant uses cookies to ensure you get the best experience",
  "chat.learn": "Learn more",
  "chat.minimize": "Minimize",
  "chat.hide": "Close",
  "chat.hidebot.text": "Close will make the avatar disappear for 15 minutes",
  "chat.hidebot": "Close (Hide) Avatar",
  "chat.restart": "Restart",
  "switch.language": "Switch Language",
  "switch.property": "Switch Property",
  "restart.converstation": "Restart Conversation",
  "chat.endtext": "Are you sure you want to end the current chat?",
  "check.availabity": "Check Availability",
  "check.availabity.submit": "Submit",
  "check.availabity.cancel": "Cancel",
  "check.availabity.adults": "Adults ",
  "check.availabity.children": "Children",
  "check.availabity.child.age": "Age - child",
  "feedback.leave": "Leave Feedback",
  "feedback.leave.message": "Leave Message",
  "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email": " Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode": "Zip Code",
  "caseform.title": "Submit a Case",
  "caseform.system": "System",
  "caseform.loading.systems": "Loading systems...",
  "caseform.select.system": "Select System",
  "caseform.error.systems": "Error loading systems",
  "caseform.scenario": "Scenario",
  "caseform.loading.scenarios": "Loading scenarios...",
  "caseform.select.scenario": "Select Scenario",
  "caseform.error.scenarios": "Error loading scenarios",
  "caseform.topic": "Topic",
  "caseform.loading.topics": "Loading topics...",
  "caseform.select.topic": "Select Topic",
  "caseform.error.topics": "Error loading topics",
  "caseform.productArea": "Product Areas",
  "caseform.loading.productAreas": "Loading product areas...",
  "caseform.select.productArea": "Select Product Area",
  "caseform.error.productAreas": "Error loading product areas",
  "caseform.module": "Modules",
  "caseform.loading.modules": "Loading modules...",
  "caseform.select.module": "Select Module",
  "caseform.error.modules": "Error loading modules",
  "caseform.feature": "Features",
  "caseform.loading.features": "Loading features...",
  "caseform.select.feature": "Select Feature",
  "caseform.error.features": "Error loading features",
  "caseform.subject": "Subject",
  "caseform.description": "Description/Steps to Reproduce",
  "caseform.attachments": "Attachments",
  "caseform.attachments.remove": "Remove",
  "caseform.submit": "Submit",
  "caseform.cancel": "Cancel",
  "caseform.success.title": "Case Created",
  "caseform.success.message": "Your case has been created successfully.",
  "caseform.success.caseNumber": "Case Number:",
  "caseform.success.transferToLiveAgent": "You are being transferred to a live agent.",
  "caseform.success.newChatWindowRightSide": "A new chat window will open on the right side of your browser.",
  "caseform.success.ok": "OK",
  "simpleaction.title": "Case Number:",
  "caseform.success.ok": "OK",
  "simpleaction.title": "Choose an Action",
  "simpleaction.body":
    "Please select one of the following options:{br}{b}Create a Case{/b} to submit a support request, or {b}Start a Chat{/b} to connect with an agent now.",
  "simpleaction.startchat": "Start a Chat",
  "simpleaction.createcase": "Create a Case",
  "caseform.error.generic": "Error in case creation.",
  "caseform.error.generic.message":
    "An error occurred while creating your case. Please try again later.",
};
export default enMessages;
